import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import BannerWithCTA from '../../components/BannerWithCta';
import MiniCardWithCta from '../../components/CardWithCta';
import campaignIcon from '../../assets/MiniCard/icon-campaign.svg';
import smsIcon from '../../assets/MiniCard/icon-sms.svg';
import waIcon from '../../assets/MiniCard/icon-wa.svg';
import automationIcon from '../../assets/MiniCard/icon-automation.svg';
import startedIcon from '../../assets/MiniCard/icon-started.svg';
import exploreIcon from '../../assets/MiniCard/icon-explore.svg';
import CustomAlert from '../../components/CustomAlert';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const Dashboard = () => {
  const { name } = useSelector((state) => state.auth.user);

  const [alertState, setAlertState] = useState({
    show: true,
    variant: 'information',
    message: 'For the best experience, we recommend using a desktop computer.',
  });

  const getGreeting = () => {
    const hour = moment().hour();
    if (hour < 12) return 'morning';
    if (hour < 18) return 'afternoon';
    return 'evening';
  };

  const bannerDesc = white_label_perkeso
    ? "Your A2P messaging dashboard is equipped with a range of tools, guides, and suggestions to help you get started with our messaging solutions. Explore the features designed to enhance your communication strategy and drive success for your business."
    : "Your elfoA2P dashboard is tailored with tools, guides, and suggestions to assist you in getting started with elfoA2P solutions.";

  return (
    <div className="DashboardContainer">
      <CustomAlert
        classes="mobile-view-alert"
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <BannerWithCTA
        title={`Good ${getGreeting()}, ${name}`}
        description={bannerDesc}
        btnText="Explore Help Center"
        btnUrl="https://help.elfo.com/"
        openNewTab
      />
      <div className="mini-card-wrapper">
        <MiniCardWithCta
          type={1}
          iconSrc={campaignIcon}
          title="SMS Campaign Builder"
          description="Create, personalize, and launch SMS campaigns from a simple step-by-step SMS campaign builder."
          btnText="Create Campaign"
          btnUrl="/dashboard/campaign/campaign-create"
        />
        <MiniCardWithCta
          type={1}
          iconSrc={smsIcon}
          title="Contacts Management"
          description="Organize and categorize your contacts using custom tags into lists for personalized messaging and enhanced engagement."
          btnText="Manage Contacts"
          btnUrl="/dashboard/contact"
        />
        <MiniCardWithCta
          type={1}
          iconSrc={startedIcon}
          title="Campaign Insights"
          description="Gain valuable insights into campaign performance with detailed SMS overviews and actionable Campaign Insights."
          btnText="Explore Insights"
          btnUrl="/dashboard/campaign/overview"
        />
        {!white_label_perkeso && (
          <>
            <MiniCardWithCta
              type={1}
              iconSrc={waIcon}
              title="WhatsApp Business API"
              description="Drive marketing conversations and sales on the world's most popular messaging app with elfo Omnichannel Solutions."
              btnText="Get Started"
              btnUrl="/dashboard/whatsapp"
            />
            <MiniCardWithCta
              type={1}
              iconSrc={automationIcon}
              title="Email Automation with SMS"
              description="Set up email API with SMS and automate SMS sending using email tools by setting triggers in automations."
              btnText="Get Started"
              btnUrl="/dashboard/email-api-home"
            />
            <MiniCardWithCta
              type={1}
              iconSrc={exploreIcon}
              title="Developer Documentation"
              description="Explore Developer Documentation for comprehensive SMS API references, technical guides, and implementation details."
              btnText="Read Now"
              btnUrl="https://docs.elfo.com"
              openNewTab
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
